import * as React from "react";
import type { ReactNode } from "react";

import { openHooksModalV5 } from "app/services/ModalService";
import { allTrackers } from "app/services/track/track";

interface IUnlockModalHookProps {
    location: string;
    componentId?: string;
    featureKey: string;
    children?: ReactNode;
}

class UnlockModalHookWrapper extends React.Component<IUnlockModalHookProps, any> {
    public render() {
        return <a onClick={this.onClick}>{this.props.children}</a>;
    }

    private onClick = () => {
        const { featureKey, componentId, location } = this.props;
        allTrackers.trackEvent("hook/Contact Us/Pop up", "click", `${location}/${componentId}`);
        openHooksModalV5(featureKey, location);
    };
}

export const UnlockModalHookWrapperBind = (props: IUnlockModalHookProps) =>
    function (childProps: any) {
        return (
            <UnlockModalHookWrapper
                {...props}
                {...childProps}
            ></UnlockModalHookWrapper>
        );
    };

export default UnlockModalHookWrapper;
